import { css, jsx } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';
import { Colors } from '../../../theme/Colors.es.js';
import '../../../theme/Shadows.es.js';
import '../../../theme/Typography.es.js';
import { LegacyTypography } from '../../../theme/LegacyTypography.es.js';
import 'react';
import { Button } from '../../navigation/Button/Button.es.js';
import { ZapCardSteps } from './ZapCardSteps.es.js';

const Styles = labelStyles("ZapCardDetails", {
  root: css`
    display: grid;
    grid-template-columns: 100%;
    gap: 20px;
    box-sizing: content-box;
    padding: 0 35px 20px 35px;
    max-width: 770px;
    margin: 0 auto;
  `,
  description: css`
    ${LegacyTypography.paragraph3};
    color: ${Colors.GrayWarm9};
  `,
  actions: [
    css`
      display: flex;
      gap: 20px;
      max-width: 320px;
      margin-left: auto;
      justify-content: end;
    `
  ]
});
const ZapCardDetails = (props) => {
  const target = props.detailsHrefTarget || "_self";
  const editorTarget = props.editorHrefTarget || "_self";
  return jsx(
    "div",
    { css: Styles.root, "data-zds": true },
    jsx(ZapCardSteps, { steps: props.steps }),
    props.children && jsx("div", { css: Styles.description, "data-zds": true }, props.children),
    jsx(
      "div",
      null,
      jsx(
        "div",
        { css: Styles.actions, "data-zds": true },
        props.detailsHref && jsx(Button, { color: "secondary", href: props.detailsHref, size: "small", target }, "See Zap details"),
        props.editorHref && jsx(Button, { color: "primary", hasShadow: true, href: props.editorHref, size: "small", target: editorTarget }, "Try it")
      )
    )
  );
};

export { ZapCardDetails };
//# sourceMappingURL=ZapCardDetails.es.js.map
